/** Define transactor kind enumeration (patient or insurance carrier). */
export const enum TransactorKind {
    Patient,
    InsuranceCarrier,
}

// for potential future use: given a transactor ID, return the transactor kind, using a purely front-end computation
export function getTransactorKind(transactorId: number | bigint): TransactorKind {
    transactorId = BigInt(transactorId);
    return transactorId >> BigInt(24) <= 0 ? 0 : Number(transactorId & BigInt(7));
}
